// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';

import type {Node} from 'react';
import type {Theme} from '@material-ui/core';

type Props = {
  children: Node,
};

const useStyles = makeStyles((theme: Theme) => ({
  taskGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}));

export default function TaskList({children}: Props) {
  const classes = useStyles();
  return <div className={classes.taskGroup}>{children}</div>;
}

TaskList.propTypes = {
  children: PropTypes.node.isRequired,
};
